<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    
    <!-- formulario -->
    <v-row>
      <v-col sm="1" lg="2" class="hidden-xs-only">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="regresar"
            >
              <v-icon> mdi-arrow-left </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2" :loading="formLoading">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Actualizar Aliado
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" sm="10" lg="8">
                <v-form ref="form" v-model="form">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Aliado*"
                    maxlength="150"
                    counter
                    v-model="aliado"
                    :rules="aliadoReglas"
                  >
                  </v-text-field>

                  <v-file-input
                    outlined
                    dense
                    prepend-icon=""
                    append-icon="mdi-paperclip"
                    accept="image/png, image/jpeg"
                    label="Logotipo"
                    truncate-length="50"
                    show-size
                    counter
                    v-model="logotipo"
                    :rules="logotipoReglas"
                  >
                  </v-file-input>

                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model="descripcion"
                  >
                  </v-textarea>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Dirección*"
                    maxlength="50"
                    counter
                    v-model="direccion"
                    :rules="direccionReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="number"
                    maxlength="10"
                    counter
                    label="Teléfono*"
                    v-model="telefono"
                    :rules="telefonoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Correo Electrónico*"
                    maxlength="50"
                    counter
                    v-model="correo"
                    :rules="correoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Contacto del Aliado"
                    maxlength="25"
                    counter
                    v-model="contactoAliado"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="number"
                    maxlength="10"
                    counter
                    label="Teléfono contacto Aliado"
                    v-model="telefonoContactoAliado"
                    :rules="telefonoContactoAliadoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Correo Electrónico"
                    maxlength="50"
                    counter
                    v-model="correoContactoAliado"
                    :rules="correoContactoAliadoReglas"
                  >
                  </v-text-field>

                  <v-btn
                    large
                    block
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="actualizar"
                  >
                    Actualizar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    formLoading: false,
    form: true,

    aliado: '',
    aliadoReglas: [
      v => !!v || "Escriba un aliado"
    ],

    logotipo: null,
    logotipoReglas: [
      v => !v || v.size < 2000000 || "El tamaño del logotipo debe ser menor que 2 MB"
    ],

    descripcion: '',

    direccion: '',
    direccionReglas: [
      v => !!v || "Escriba una dirección"
    ],

    telefono: '',
    telefonoReglas: [
      v => !!v || "Escriba un número de teléfono",
      v => !v || v > 0 || "El número debe ser mayor a 0",
      v => !v || v.length <= 10 || "Maximo 10 digitos"
    ],

    correo: '',
    correoReglas: [
      v => !!v || "Escriba un correo electrónico",
      v => /.+@.+\..+/.test(v) || "Correo electrónico no válido"
    ],

    contactoAliado: '',

    telefonoContactoAliado: '',
    telefonoContactoAliadoReglas: [
      v => !v || v > 0 || "El número debe ser mayor a 0",
      v => !v || v.length <= 10 || "Maximo 10 digitos",
    ],

    correoContactoAliado: '',
    correoContactoAliadoReglas: [
      v => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ]
  }),

  components: {
    Alert,
  },
  



  mounted() {
    this.$store.dispatch("obtenerAliadoCampesenaId", this.$route.params.idAliado)
    
    
    setTimeout(() => {
      const data = this.aliadoActualizar
    
      this.aliado = data.aliado;
      this.descripcion = data.descripcion;
      this.direccion = data.direccion;
      this.telefono = data.telefono;
      this.correo = data.correo;
      this.contactoAliado = data.contacto_aliado;
      this.telefonoContactoAliado = data.telefono_contacto_aliado;
      this.correoContactoAliado = data.correo_contacto_aliado;  
    }, 1000);
  },
  computed:{
    aliadoActualizar() {
      return this.$store.getters.obtenerAliadoCampesena;
    },
  },

  methods: {
    actualizar() {
      if (this.$refs.form.validate()) {
        this.formLoading = true;
      
        const aliado = new FormData();
        aliado.set("_method", "PUT");
        aliado.set('id_aliado', this.$route.params.idAliado);
        aliado.set('aliado', this.aliado.toLowerCase());
        aliado.set('descripcion', this.descripcion);
        aliado.set('direccion', this.direccion);
        aliado.set('telefono', this.telefono);
        aliado.set('correo', this.correo.toLowerCase());
        aliado.set('contacto_aliado', this.contactoAliado.toLowerCase());
        aliado.set('telefono_contacto_aliado', this.telefonoContactoAliado);
        aliado.set('correo_contacto_aliado', this.correoContactoAliado.toLowerCase());
        
      
        if (this.logotipo) {
          aliado.append('logotipo', this.logotipo);
        }
        this.$store.dispatch("actualizarAliadoCampesena", aliado)
        .then((response) => {
          if (response.status == "success") {
            this.formLoading = false;

            let message = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            setTimeout(() => {
              this.alert = false
              this.$router.replace({ name: "campesena-aliado-gestionar" });
            }, 2000);
          } 
          else {
            this.formLoading  = false;
            this.alertType    = "error--text";
            this.alertTitle   = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            this.alert        = true;

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
        })
        .catch(() => {});
      }
    },

    regresar() {
      this.$router.back()
    },
  },
};
</script>